import { Image, InsertDriveFile, Preview } from "@mui/icons-material";

import { getExtension } from "../../../../ui library/helpers/functions";
import CustomIconButton from "../../../../ui library/components/buttons/CustomIconButton";
import Colors from "../../../../global/Colors";
import getDocumentTypeName from "../../../../global/getDocumentTypeName";

const DocumentTypeCol = ({ document, docTypeOptions, handleOpenDocument }) => {
    const imageExtensions = ["png", "jpg", "jpeg"];
    const fileName = document.fileName;
    const isImage = imageExtensions.includes(getExtension(fileName));

    return (
        <div className="flex items-center w-full">
            <CustomIconButton 
                tooltipText={fileName}
                iconVisible
                buttonClasses="cursor-default"
                handleOnClick={() => null} 
                CustomIcon={isImage ? <Image /> : <InsertDriveFile />} 
            />
            <CustomIconButton
                tooltipText={ isImage ? "View Image" : "View Document" }
                iconVisible
                handleOnClick={() => handleOpenDocument(document)} 
                CustomIcon={<Preview style={{ color: Colors.blue[500] }} />} 
            />
            <span>{getDocumentTypeName(docTypeOptions, document?.documentType)}</span>
        </div>
  )}

export default DocumentTypeCol